import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/styles';
import {Container, Grid, Typography} from '@material-ui/core';

import {InferPropTypes} from 'commons/types/Types';
import {ErrorTemplateStyles} from 'assets/tss/layouts/components';

function ErrorTemplate(
    props: InferPropTypes<typeof ErrorTemplate.propTypes, typeof ErrorTemplateStyles>
) {
    const {classes, error, defaultMessage} = props;

    return (
        <div className='ErrorTemplate'>
            {/* <Paper
                variant='outlined'
                className={clsx(classes.paper, 'm-0 w-100 mb-3')}> */}
            <Container maxWidth='lg' className={clsx(classes.container, classes.container, 'p-1')}>
                <Grid
                    container
                    spacing={2}
                    alignContent='center'
                    justifyContent='center'
                    direction='row'
                    className='mb-3'>
                    <Grid item xs={12} sm={12} md={12}>
                        {error && error.process && (
                            <Typography className={classes.header}>{error.process}</Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    alignContent='center'
                    justifyContent='center'
                    direction='row'
                    className='mb-3'>
                    <Grid item xs={12} sm={12} md={12}>
                        <Typography className={clsx(classes.content, classes.textBreaker)}>
                            {error && error.message ? error.message : defaultMessage}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    alignContent='center'
                    justifyContent='center'
                    direction='row'
                    className='mb-3'>
                    <Grid item xs={12} sm={10} md={12}>
                        <Typography
                            variant='body1'
                            display='block'
                            gutterBottom
                            className={classes.default}>
                            <ul className='pl-3'>
                                {error.errors
                                    .filter((item) => item)
                                    .map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                            </ul>
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            {/* </Paper> */}
        </div>
    );
}

ErrorTemplate.propTypes = {
    error: PropTypes.shape({
        process: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        errors: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    }).isRequired,
    defaultMessage: PropTypes.string.isRequired,
};

export default withStyles(ErrorTemplateStyles)(ErrorTemplate);
